import ProviderService from '../../services/providers.service';
import ReportingService from '../../services/reporting.service';
import {TradeReportType} from './reportFilter.enums';
import axios from 'axios'
import { format } from 'date-fns'

var CancelToken = axios.CancelToken;
var Source = null;

export async function getProviders(store) {

    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports
        },
    }))
    try {

        const providers = await ProviderService().getAllProviders();
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                providers: providers,
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                providers: [],
            },
        }))
    }
}

export const getAllTradeRuleCourseList = async (store,{providerId,reportType}) => {
    
    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports
        },
    }))
    try {
        const data = await ReportingService().getAllTradeRuleCourseList(providerId)
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                tradeRuleCoursesList: data,
                soldVsUnsoldTradeRuleCoursesList: reportType == TradeReportType.SoldVsUnsoldTradeRoundReport ? data : store.state.Reports.soldVsUnsoldTradeRuleCoursesList,
                bankingAndReAllocationTradeRuleCoursesList: reportType == TradeReportType.BankingAndReAllocationReport ? data : store.state.Reports.bankingAndReAllocationTradeRuleCoursesList,
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                tradeRuleCoursesList: [],
                soldVsUnsoldTradeRuleCoursesList: reportType == TradeReportType.SoldVsUnsoldTradeRoundReport ? [] : store.state.Reports.soldVsUnsoldTradeRuleCoursesList,
                bankingAndReAllocationTradeRuleCoursesList: reportType == TradeReportType.BankingAndReAllocationReport ? [] : store.state.Reports.bankingAndReAllocationTradeRuleCoursesList,
            },
        }))
    }
}

export const getSoldAndUnsoldTradeRoundReport = async (store,{filters}) => {
    
    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports,
            soldVsUnsoldReportMessage : '',
        },
    }))
    try {
        var filterItem = ''
        filters.courseFilter.forEach(element => {
            filterItem = filterItem + 'courseFilter='+element+'&'
            
        });
        if(filters.dayFilter == 6){
            const startDate = format(filters.customDate.startDate, 'yyyy-MM-dd');
            const endDate = format(filters.customDate.endDate, 'yyyy-MM-dd');
            filterItem = filterItem+'FilterName='+ filters.dayFilter+'&customDate.startDate='+startDate+'&customDate.endDate='+endDate
            
        }
        else{
            filterItem = filterItem +'FilterName='+ filters.dayFilter
        }
         // for rule 
      if(filters.ruleFilter!=undefined && filters.ruleFilter.length>0)
      {          
         filters.ruleFilter.forEach(element => {
             filterItem = filterItem + '&ruleIds='+element
             
         });
     }    
     
        await ReportingService().getSoldAndUnsoldTradeRoundReport(filterItem,filters.providerFilter)
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldVsUnsoldReportMessage : 'Report successfully generated',
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldVsUnsoldReportMessage: 'Report Not Generated',
            },
        }))
    }
}

export const getSoldTradeRoundReport = async (store,{filters}) => {
    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports,
            soldReportMessage : '',
        },
    }))
    try {
        var filterItem = ''
        if(filters.weekFilter == 6 || filters.weekFilter == 7){
            const startDate = format(filters.customDate.startDate, 'yyyy-MM-dd');
            const endDate = format(filters.customDate.endDate, 'yyyy-MM-dd');
            filterItem = filterItem+'FilterName='+ filters.weekFilter+'&customDate.startDate='+startDate+'&customDate.endDate='+endDate
            
        }
        else{
            filterItem = filterItem +'FilterName='+ filters.weekFilter
        }
        
      // for rule 
      if(filters.ruleFilter!=undefined && filters.ruleFilter.length>0)
      {          
         filters.ruleFilter.forEach(element => {
             filterItem = filterItem + '&ruleIds='+element
             
         });
     }    

        await ReportingService().getSoldTradeRoundReport(filterItem,filters.providerFilter)
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldReportMessage : 'Report successfully generated',
            },
        }))
    }
    catch (error) {
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldReportMessage: 'Report Not Generated',
            },
        }))
    }
}

export const getBankingAndReAllocationsReport = async (store,{filters}) => {
    
    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports,
            bankingAndReAllocationsReportMessage : '',
        },
    }))
    try {
        
        var filterItem = ''      
// for date
var fromDate;
var toDate;

 // for date
if(filters.customDate !=undefined){ 
   
    if(filters.customDate.startDate!=undefined) {
         fromDate = format(filters.customDate.startDate, 'yyyy-MM-dd');
        filterItem=filterItem + 'fromDate='+fromDate+'&'
    } 
    if(filters.customDate.endDate!=undefined) {
        toDate = format(filters.customDate.endDate, 'yyyy-MM-dd');
        filterItem=filterItem + 'toDate='+toDate+'&'
    }
    else if(filters.customDate.endDate==undefined && fromDate!=undefined)
    {
        filterItem=filterItem + 'toDate='+fromDate+'&'
    } 
}
    // for course
        if(filters.courseFilter!=undefined && filters.courseFilter.length>0){
            filters.courseFilter.forEach(element => {
                filterItem = filterItem + 'courseIds='+element+'&'
                
            });
        }        
      // for rule 
         if(filters.ruleFilter!=undefined && filters.ruleFilter.length>0)
         {
             if(filterItem.length>0){

             }
            filters.ruleFilter.forEach(element => {
                filterItem = filterItem + 'ruleIds='+element+'&'
                
            });
        }
          // to remove extra '&' operator from last
        if(filterItem!="" && filterItem.length>0)
        {
                filterItem = filterItem.substring(0, filterItem.length - 1);
        }

       
        await ReportingService().getBankingAndReAllocationsReport(filterItem,filters.providerFilter)
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                bankingAndReAllocationsReportMessage : 'Report successfully generated',
            },
        }))
    }
    catch (error) {
        console.log(error);
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                bankingAndReAllocationsReportMessage: 'Report Not Generated',
            },
        }))
    }
}

export async function getAllTradeRuleList(store,{providerId,courseFilter,reportType}){
    
    store.setState(prevState => ({
        ...prevState,
        Reports: {
            ...store.state.Reports
        },
    }))
    try {
var filterItem=''
        if(courseFilter!==undefined && courseFilter.length>0){
            courseFilter.forEach(element => {
                filterItem = filterItem + 'courseIds='+element+'&'
                
            });
              // to remove extra '&' operator from last
        if(filterItem!=="" && filterItem.length>0)
        {
                filterItem = filterItem.substring(0, filterItem.length - 1);
        }
    } 

        const data = await ReportingService().getAllTradeRuleList(providerId,filterItem)
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldVsUnsoldTradeRuleList: reportType == TradeReportType.SoldVsUnsoldTradeRoundReport ? data : store.state.Reports.soldVsUnsoldTradeRuleList,
                soldTradeRuleList: reportType == TradeReportType.SoldTradeRoundReport ? data : store.state.Reports.soldTradeRuleList,
                bankingAndReAllocationTradeRuleList: reportType == TradeReportType.BankingAndReAllocationReport ? data : store.state.Reports.bankingAndReAllocationTradeRuleList,
            },
        }))
    }
    catch (error) {
        
        store.setState(prevState => ({
            ...prevState,
            Reports: {
                ...store.state.Reports,
                soldVsUnsoldTradeRuleList: reportType == TradeReportType.SoldVsUnsoldTradeRoundReport ? [] : store.state.Reports.soldVsUnsoldTradeRuleList,
                soldTradeRuleList: reportType == TradeReportType.SoldTradeRoundReport ? [] : store.state.Reports.soldTradeRuleList,
                bankingAndReAllocationTradeRuleList: reportType == TradeReportType.BankingAndReAllocationReport ? [] : store.state.Reports.bankingAndReAllocationTradeRuleList,
            },
        }))
    }
}
